import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5042FF4E-78E5-43D5-B992-1AAEAE51AB25
 * name toaster
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toaster.svg
 * tags
 * - Home Automation 
 */
export const ToasterIcon = createSvgIcon(<><path d="M21 11A2 2 0 0 0 19 9H5A2 2 0 0 0 3 11H2V13H3V20H21V13H22V11M17 15A2 2 0 1 1 19 13A2 2 0 0 1 17 15M18 8H6C6.33 5.75 8.88 4 12 4S17.63 5.75 18 8Z" /></>, 'ToasterIcon');
export default ToasterIcon